/* HELIO — interacciones propias (prefijo mt-) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var prog = function (p, a, b) { return clamp((p - a) / (b - a), 0, 1); };
  var easeOut = function (t) { return 1 - Math.pow(1 - t, 3); };
  var easeInOut = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

  /* ---------- Animaciones de entrada ---------- */
  var revealObserver = null;
  function initReveal(scope) {
    var els = scope.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('mt-visible');
            revealObserver.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- 1. La caída ---------- */
  function hexToRgb(hex) {
    var h = (hex || '#a9cbf2').replace('#', '');
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    var n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function rand(seed) {
    var s = seed % 2147483647;
    if (s <= 0) s += 2147483646;
    return function () { s = (s * 16807) % 2147483647; return (s - 1) / 2147483646; };
  }

  function initCaida(scope) {
    scope.querySelectorAll('[data-mt-caida]').forEach(function (el) {
      if (el.dataset.mtListo) return;
      el.dataset.mtListo = '1';

      var sticky = el.querySelector('.mt-caida__sticky');
      var escena = el.querySelector('.mt-caida__escena');
      var gafa = el.querySelector('.mt-caida__gafa');
      var suelo = el.querySelector('.mt-caida__suelo');
      var canvas = el.querySelector('.mt-caida__fragmentos');
      var textoFinal = el.querySelector('.mt-caida__texto--final');
      var ctx = canvas.getContext('2d');
      var nFrag = parseInt(el.dataset.fragmentos || '70', 10);
      var colFrag = hexToRgb(el.dataset.colorFragmentos);
      var sueloRel = parseFloat(el.dataset.suelo || '70') / 100;
      var finalClaro = el.dataset.finalClaro === 'true';
      var W = 0, H = 0, dpr = 1;

      if (reduceMotion) {
        el.classList.add('mt-caida--estatico');
        aplicar(1);
        return;
      }

      // Fragmentos y motas (deterministas: el scroll hacia atrás los recompone)
      var r = rand(1977);
      var fragmentos = [];
      for (var i = 0; i < nFrag; i++) {
        var lado = r() < 0.5 ? 0 : 1;
        var lente = lado === 0 ? [0.03, 0.40, 0.22, 0.98] : [0.50, 0.86, 0.24, 0.98];
        // punto en el perímetro de la lente
        var t = r(), u = r(), px, py;
        if (t < 0.25) { px = lerp(lente[0], lente[1], u); py = lente[2]; }
        else if (t < 0.5) { px = lerp(lente[0], lente[1], u); py = lente[3]; }
        else if (t < 0.75) { px = lente[0]; py = lerp(lente[2], lente[3], u); }
        else { px = lente[1]; py = lerp(lente[2], lente[3], u); }
        var cx = (lente[0] + lente[1]) / 2;
        var dir = px < cx ? -1 : 1;
        fragmentos.push({
          px: px, py: py,
          vx: dir * lerp(0.15, 1.0, r()) + (r() - 0.5) * 0.5,
          vy: -lerp(0.35, 1.25, r()),
          rot: r() * Math.PI * 2,
          vr: (r() - 0.5) * 14,
          s: lerp(3, 11, r()),
          forma: [r(), r(), r(), r()],
          brilla: r() < 0.35
        });
      }
      var motas = [];
      for (var m = 0; m < 70; m++) motas.push({ x: r(), y: r(), z: lerp(0.3, 1, r()), s: lerp(0.6, 2.2, r()) });

      function medir() {
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        W = sticky.clientWidth;
        H = sticky.clientHeight;
        canvas.width = W * dpr;
        canvas.height = H * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }

      function dibujar(p, gx, gy, gw, gh, sueloPx) {
        ctx.clearRect(0, 0, W, H);
        var kFinal = prog(p, 0.84, 0.97);

        // Motas de luz: suben mientras las gafas caen (sensación de caída)
        var kCae = prog(p, 0.06, 0.5);
        var aMotas = (1 - prog(p, 0.46, 0.54)) * Math.min(1, kCae * 6);
        if (aMotas > 0.01) {
          motas.forEach(function (mo) {
            var y = ((mo.y - kCae * 2.4 * mo.z) % 1 + 1) % 1;
            ctx.globalAlpha = aMotas * 0.55 * mo.z;
            ctx.fillStyle = '#f6e7cf';
            ctx.fillRect(mo.x * W, y * H, mo.s, mo.s * (1 + kCae * 6 * mo.z));
          });
        }

        // Fragmentos de la talla
        var kF = prog(p, 0.5, 0.82);
        if (kF <= 0 || kF >= 1) { ctx.globalAlpha = 1; return; }
        var tau = kF * 1.6;
        var g = 2.2 * H;
        var alfa = (1 - prog(kF, 0.72, 1)) * (1 - kFinal);
        fragmentos.forEach(function (f) {
          var x0 = gx + f.px * gw, y0 = gy + f.py * gh;
          var vx = f.vx * W * 0.32, vy = f.vy * H * 0.9;
          var tl = tau;
          // tiempo de aterrizaje en el suelo
          var disc = vy * vy + 2 * g * (sueloPx - y0);
          var tLand = disc > 0 ? (-vy + Math.sqrt(disc)) / g : tau;
          var x, y, rot;
          if (tau < tLand) {
            x = x0 + vx * tau; y = y0 + vy * tau + 0.5 * g * tau * tau; rot = f.rot + f.vr * tau;
          } else {
            var extra = tau - tLand;
            x = x0 + vx * tLand + vx * 0.22 * (1 - Math.exp(-extra * 3));
            y = sueloPx - 1; rot = f.rot + f.vr * tLand;
            tl = tLand;
          }
          ctx.save();
          ctx.translate(x, y);
          ctx.rotate(rot);
          ctx.globalAlpha = alfa;
          var s = f.s;
          ctx.beginPath();
          ctx.moveTo(-s * f.forma[0], -s * 0.6);
          ctx.lineTo(s * (0.4 + f.forma[1]), -s * f.forma[2] * 0.5);
          ctx.lineTo(s * f.forma[3] * 0.3, s * 0.8);
          ctx.closePath();
          ctx.fillStyle = 'rgba(' + colFrag[0] + ',' + colFrag[1] + ',' + colFrag[2] + ',0.55)';
          ctx.fill();
          ctx.strokeStyle = 'rgba(255,255,255,0.85)';
          ctx.lineWidth = 0.7;
          ctx.stroke();
          if (f.brilla) {
            var tw = Math.abs(Math.sin(rot * 2.3));
            ctx.globalAlpha = alfa * tw;
            ctx.fillStyle = '#ffffff';
            ctx.beginPath();
            var b = s * 0.9;
            ctx.moveTo(0, -b); ctx.lineTo(b * 0.18, 0); ctx.lineTo(0, b); ctx.lineTo(-b * 0.18, 0); ctx.closePath();
            ctx.moveTo(-b, 0); ctx.lineTo(0, b * 0.18); ctx.lineTo(b, 0); ctx.lineTo(0, -b * 0.18); ctx.closePath();
            ctx.fill();
          }
          ctx.restore();
        });
        ctx.globalAlpha = 1;
      }

      function aplicar(p) {
        var st = el.style;
        var vh = H || window.innerHeight;
        var sueloRest = sueloRel * vh;

        // Fases
        var kSalida = prog(p, 0.03, 0.14);
        var kCae = prog(p, 0.06, 0.5);
        var kTalla = prog(p, 0.5, 0.57);
        var kFlash = p < 0.5 ? prog(p, 0.485, 0.5) : 1 - prog(p, 0.5, 0.56);
        var kBrillo = p < 0.6 ? 0 : (p < 0.72 ? 1 - Math.abs(prog(p, 0.6, 0.72) * 2 - 1) : 0);
        var kTexto = prog(p, 0.62, 0.74);
        var kFinal = prog(p, 0.84, 0.97);

        // El suelo sube desde abajo (la cámara acompaña a las gafas)
        var e = kCae * kCae;
        var sueloPx = lerp(vh * 1.45, sueloRest, e);
        // Las gafas bajan un poco y giran mientras caen
        var gafaBase = lerp(sueloRest - vh * 0.16, sueloRest, e);
        var rebote = 0;
        if (p > 0.5 && p < 0.62) {
          var ub = prog(p, 0.5, 0.62);
          rebote = -Math.sin(Math.PI * ub) * vh * 0.035 * (1 - ub);
        }
        var giroZ = lerp(-11, 0, easeOut(kCae)) + Math.sin(kCae * 9) * 3 * (1 - kCae);
        var giroX = lerp(32, 0, easeOut(kCae));
        var giroY = lerp(-22, 0, easeInOut(kCae));
        var escala = lerp(0.86, 1, easeOut(kCae));
        var temblor = 0;
        if (p > 0.5 && p < 0.56) temblor = Math.sin(p * 900) * 7 * (1 - prog(p, 0.5, 0.56));

        st.setProperty('--k-salida', kSalida.toFixed(4));
        st.setProperty('--k-talla', kTalla.toFixed(4));
        st.setProperty('--k-flash', kFlash.toFixed(4));
        st.setProperty('--k-brillo', kBrillo.toFixed(4));
        st.setProperty('--brillo-x', lerp(-120, 120, prog(p, 0.6, 0.72)).toFixed(1) + '%');
        st.setProperty('--k-texto-final', kTexto.toFixed(4));
        st.setProperty('--k-final', kFinal.toFixed(4));
        st.setProperty('--k-reflejo', (prog(p, 0.38, 0.5) * 0.9).toFixed(4));
        st.setProperty('--k-sombra', (prog(p, 0.3, 0.5)).toFixed(4));
        st.setProperty('--k-sombra-x', lerp(0.35, 1, prog(p, 0.3, 0.5)).toFixed(4));

        escena.style.top = (gafaBase + rebote) + 'px';
        escena.style.marginLeft = temblor + 'px';
        gafa.style.transform = 'rotateX(' + giroX.toFixed(2) + 'deg) rotateY(' + giroY.toFixed(2) + 'deg) rotateZ(' + giroZ.toFixed(2) + 'deg) scale(' + escala.toFixed(4) + ')';
        suelo.style.transform = 'translateY(' + (sueloPx - vh * 0.66).toFixed(1) + 'px)';
        el.classList.toggle('mt-caida--final-claro', finalClaro && kFinal > 0.5);
        if (textoFinal) textoFinal.classList.toggle('is-activo', kTexto > 0.6);

        if (!W) return;
        var gr = gafa.getBoundingClientRect();
        var sr = sticky.getBoundingClientRect();
        dibujar(p, gr.left - sr.left, gr.top - sr.top, gr.width, gr.height, sueloRest);
      }

      var pendiente = false;
      function alScroll() {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () {
          pendiente = false;
          var rect = el.getBoundingClientRect();
          var total = rect.height - window.innerHeight;
          var p = total > 0 ? clamp(-rect.top / total, 0, 1) : 0;
          aplicar(p);
        });
      }
      medir();
      alScroll();
      window.addEventListener('scroll', alScroll, { passive: true });
      window.addEventListener('resize', function () { medir(); alScroll(); });
    });
  }

  /* ---------- 4. Elige tu tono ---------- */
  function initTono(scope) {
    scope.querySelectorAll('[data-mt-tono]').forEach(function (sec) {
      if (sec.dataset.mtListo) return;
      sec.dataset.mtListo = '1';
      var btns = sec.querySelectorAll('[data-tono-btn]');
      var imgs = sec.querySelectorAll('[data-tono-img]');
      var nombre = sec.querySelector('[data-tono-nombre]');
      var link = sec.querySelector('[data-tono-link]');
      function activar(i) {
        var b = btns[i];
        if (!b) return;
        sec.style.setProperty('--mt-tono-fondo', b.dataset.fondo);
        sec.style.setProperty('--mt-tono-a', b.dataset.a);
        sec.style.setProperty('--mt-tono-b', b.dataset.b);
        btns.forEach(function (x, j) { x.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        imgs.forEach(function (x, j) { x.classList.toggle('is-activa', j === i); });
        if (nombre) nombre.textContent = b.dataset.nombre;
        if (link) {
          if (b.dataset.url) { link.href = b.dataset.url; link.hidden = false; } else { link.hidden = true; }
        }
      }
      btns.forEach(function (b, i) { b.addEventListener('click', function () { activar(i); }); });
      activar(0);
    });
  }

  /* ---------- 5. Escena fija ---------- */
  function initEscena(scope) {
    scope.querySelectorAll('[data-mt-escena]').forEach(function (sec) {
      if (sec.dataset.mtListo) return;
      sec.dataset.mtListo = '1';
      var pasos = sec.querySelectorAll('[data-paso]');
      var imgs = sec.querySelectorAll('[data-escena-img]');
      var cont = sec.querySelector('[data-escena-contador]');
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = parseInt(e.target.dataset.paso, 10);
          pasos.forEach(function (p, j) { p.classList.toggle('is-activo', j === i); });
          imgs.forEach(function (im, j) { im.classList.toggle('is-activa', j === i); });
          if (cont) cont.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(pasos.length).padStart(2, '0');
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { io.observe(p); });
    });
  }

  /* ---------- 6. Comparador ---------- */
  function initComparador(scope) {
    scope.querySelectorAll('[data-mt-comp]').forEach(function (c) {
      if (c.dataset.mtListo) return;
      c.dataset.mtListo = '1';
      var r = c.querySelector('input[type=range]');
      var set = function () { c.style.setProperty('--pos', r.value + '%'); };
      r.addEventListener('input', set);
      set();
    });
  }

  /* ---------- 7. Filtros de modelos ---------- */
  function initFiltros(scope) {
    scope.querySelectorAll('[data-mt-filtros]').forEach(function (sec) {
      if (sec.dataset.mtListo) return;
      sec.dataset.mtListo = '1';
      var btns = sec.querySelectorAll('[data-filtro]');
      var items = sec.querySelectorAll('[data-colecciones]');
      var filas = sec.querySelectorAll('[data-sub-de]');
      function filtrar(f) {
        items.forEach(function (it) {
          var ok = f === '*' || (' ' + it.dataset.colecciones + ' ').indexOf(' ' + f + ' ') > -1;
          it.hidden = !ok;
        });
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var f = b.dataset.filtro;
          var fila = b.closest('[data-sub-de]');
          // subfiltro: al volver a pulsarlo se quita y se ve toda la línea
          if (fila) {
            var quitar = b.getAttribute('aria-pressed') === 'true';
            fila.querySelectorAll('[data-filtro]').forEach(function (x) { x.setAttribute('aria-pressed', !quitar && x === b ? 'true' : 'false'); });
            filtrar(quitar ? fila.dataset.subDe : f);
            return;
          }
          btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          filas.forEach(function (x) { x.hidden = x.dataset.subDe !== f; });
          filtrar(f);
        });
      });
    });
  }

  /* ---------- 11. Opiniones ---------- */
  function initOpiniones(scope) {
    scope.querySelectorAll('[data-mt-opiniones]').forEach(function (sec) {
      if (sec.dataset.mtListo) return;
      sec.dataset.mtListo = '1';
      var items = sec.querySelectorAll('.mt-opinion');
      var puntos = sec.querySelectorAll('[data-op]');
      var seg = parseInt(sec.dataset.segundos || '6', 10) * 1000;
      var i = 0, timer;
      function ir(n) {
        i = (n + items.length) % items.length;
        items.forEach(function (x, j) { x.classList.toggle('is-activa', j === i); });
        puntos.forEach(function (x, j) { x.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      }
      function auto() { clearInterval(timer); if (items.length > 1 && !reduceMotion) timer = setInterval(function () { ir(i + 1); }, seg); }
      puntos.forEach(function (p, j) { p.addEventListener('click', function () { ir(j); auto(); }); });
      ir(0); auto();
    });
  }

  /* ---------- 13. Parallax del cierre ---------- */
  function initParallax(scope) {
    var els = scope.querySelectorAll('[data-mt-parallax]');
    if (!els.length || reduceMotion) return;
    var pend = false;
    function up() {
      pend = false;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var k = parseFloat(el.dataset.mtParallax || '0.12');
        var c = r.top + r.height / 2 - window.innerHeight / 2;
        el.style.setProperty('--mt-parallax', (-c * k).toFixed(1) + 'px');
      });
    }
    window.addEventListener('scroll', function () { if (!pend) { pend = true; requestAnimationFrame(up); } }, { passive: true });
    up();
  }

  /* ---------- Color de la página según el tono de la lente ---------- */
  var TONOS = [
    ['azul y ambar', '#E3E1D6'], ['gris y rosa', '#ECDFE2'], ['verde agua', '#D9EBE6'], ['azul cielo', '#DDE9F4'],
    ['azul intenso', '#D3E0EE'], ['champan', '#F4E9D8'], ['transparente', '#F3F1EE'], ['amarillo', '#F5EDCD'],
    ['ambar', '#F1E4CA'], ['morado', '#E7E0EF'], ['lila', '#E9E2F0'], ['rosa', '#F3DEE3'], ['rojo', '#F2DAD5'],
    ['cafe', '#ECDFCF'], ['te', '#EEE1D0'], ['negro', '#E0DEDB'], ['gris', '#E3E3E6'], ['verde', '#DEE9DC'], ['azul', '#D8E4F0']
  ];
  function normal(t) { return (t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
  function tonoPagina(sel) {
    var txt = normal((sel || []).join(' '));
    var mejor = null, pos = 1e9;
    TONOS.forEach(function (t) {
      var m = new RegExp('(^|[^a-z])' + t[0] + '([^a-z]|$)').exec(txt);
      if (m && (m.index < pos || (m.index === pos && t[0].length > mejor[0].length))) { pos = m.index; mejor = t; }
    });
    document.documentElement.style.setProperty('--mt-tono-pagina', mejor ? mejor[1] : '#F3EEE6');
  }

  /* ---------- Producto: galería + variantes ---------- */
  function initProducto(scope) {
    scope.querySelectorAll('[data-mt-producto]').forEach(function (sec) {
      if (sec.dataset.mtListo) return;
      sec.dataset.mtListo = '1';

      // Galería
      var slides = sec.querySelectorAll('[data-slide]');
      var minis = sec.querySelectorAll('[data-mini]');
      var actual = 0;
      function verSlide(i) {
        if (!slides.length) return;
        actual = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.classList.toggle('is-activa', j === actual); });
        minis.forEach(function (m, j) { m.setAttribute('aria-current', j === actual ? 'true' : 'false'); });
      }
      function verMedia(id) {
        slides.forEach(function (s, j) { if (s.dataset.mediaId === String(id)) verSlide(j); });
      }
      minis.forEach(function (m, j) { m.addEventListener('click', function () { verSlide(j); }); });
      var prev = sec.querySelector('[data-galeria-prev]');
      var next = sec.querySelector('[data-galeria-next]');
      if (prev) prev.addEventListener('click', function () { verSlide(actual - 1); });
      if (next) next.addEventListener('click', function () { verSlide(actual + 1); });
      var principal = sec.querySelector('.mt-galeria__principal');
      if (principal) {
        var x0 = null;
        principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        principal.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) verSlide(actual + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }

      // Variantes
      var dataEl = sec.querySelector('[data-variantes]');
      if (!dataEl) return;
      var variantes = JSON.parse(dataEl.textContent);
      var form = sec.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = sec.querySelector('[data-boton-compra]');
      var botonTexto = boton ? boton.querySelector('[data-boton-texto]') : null;
      var precio = sec.querySelector('[data-precio]');
      var antes = sec.querySelector('[data-precio-antes]');
      var txtAgotado = sec.dataset.textoAgotado || 'Agotado';
      var txtComprar = sec.dataset.textoComprar || 'Añadir a la bolsa';

      function seleccion() {
        var sel = [];
        sec.querySelectorAll('[data-opcion]').forEach(function (fs) {
          var pos = parseInt(fs.dataset.opcion, 10);
          var chk = fs.querySelector('input:checked');
          var hid = fs.querySelector('input[type=hidden]');
          sel[pos] = chk ? chk.value : (hid ? hid.value : null);
          var leyenda = fs.querySelector('[data-valor-actual]');
          if (leyenda && chk) leyenda.textContent = chk.dataset.etiqueta || chk.value;
        });
        return sel;
      }
      function actualizar() {
        var sel = seleccion();
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return sel[i] == null || sel[i] === o; });
        });
        if (!v) {
          if (boton) { boton.disabled = true; if (botonTexto) botonTexto.textContent = sec.dataset.textoNoDisponible || 'No disponible'; }
          return;
        }
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = v.price;
        if (antes) { antes.textContent = v.compare || ''; antes.hidden = !v.compare; }
        if (boton) {
          boton.disabled = !v.available;
          if (botonTexto) botonTexto.textContent = v.available ? txtComprar : txtAgotado;
        }
        if (v.media) verMedia(v.media);
        tonoPagina(sel);
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      sec.querySelectorAll('[data-opcion] input[type=radio]').forEach(function (inp) {
        inp.addEventListener('change', actualizar);
      });
      tonoPagina(seleccion());
    });
  }

  /* ---------- Receta de lentes graduados (snippet mt-receta) ---------- */
  function initReceta(scope) {
    scope.querySelectorAll('[data-receta]').forEach(function (box) {
      if (box.dataset.mtListo) return;
      box.dataset.mtListo = '1';
      var sec = box.closest('[data-mt-producto]') || document;
      var pf = box.closest('product-form') || box.closest('form');
      var aviso = box.querySelector('[data-receta-aviso]');
      var fotoBtn = box.querySelector('[data-receta-foto]');
      var proximo = box.querySelector('[data-receta-proximo]');
      var guia = box.querySelector('[data-receta-guia]');
      var vistoGraduado = false;

      // contador de interés: cuántos eligen graduación, pulsan "Subir foto" (aún no existe), abren la guía y añaden con receta.
      // "nuevo" = primera vez hoy en este navegador (para contar personas además de clics); máx. 5 avisos por evento y página
      var enviados = {};
      function contar(ev) {
        if (!box.dataset.contador || (enviados[ev] = (enviados[ev] || 0) + 1) > 5) return;
        var hoy = new Date().toISOString().slice(0, 10), nuevo = false;
        try { nuevo = localStorage.getItem('mt-ev-' + ev) !== hoy; localStorage.setItem('mt-ev-' + ev, hoy); } catch (e) {}
        try { navigator.sendBeacon(box.dataset.contador, new Blob([JSON.stringify({ e: ev, nuevo: nuevo })], { type: 'text/plain' })); } catch (e) {}
        if (typeof window.clarity === 'function') window.clarity('event', 'receta_' + ev);
      }
      if (fotoBtn && proximo) fotoBtn.addEventListener('click', function () {
        proximo.hidden = false;
        fotoBtn.setAttribute('aria-expanded', 'true');
        contar('foto');
      });
      if (guia) guia.addEventListener('toggle', function () { if (guia.open) contar('guia'); });

      // listas de valores: data-rango="desde,hasta,paso,decimales"; con signo (esfera, cilindro) van de + a -
      box.querySelectorAll('select[data-rango]').forEach(function (s) {
        var r = s.dataset.rango.split(',');
        var de = parseFloat(r[0]), a = parseFloat(r[1]), paso = parseFloat(r[2]), dec = parseInt(r[3], 10);
        var conSigno = de < 0;
        if (s.dataset.vacio) s.add(new Option(s.dataset.vacio, s.dataset.vacioValor || ''));
        var n = Math.round((a - de) / paso);
        for (var k = 0; k <= n; k++) {
          var x = conSigno ? a - k * paso : de + k * paso;
          var t = Math.abs(x) < 1e-9 ? (0).toFixed(dec) : x.toFixed(dec);
          if (conSigno && x > 1e-9) t = '+' + t;
          s.add(new Option(t, t));
        }
        if (s.dataset.inicial) s.value = s.dataset.inicial;
      });
      // texto con el límite de este modelo (sale del rango de su lista)
      [['esf', 'select[data-esfera]'], ['cil', 'select[data-cilindro]']].forEach(function (par) {
        var s = box.querySelector(par[1]), t = box.querySelector('[data-lim-' + par[0] + ']');
        if (!s || !t) return;
        var r = s.dataset.rango.split(','), menos = Math.abs(parseFloat(r[0])).toFixed(2), mas = parseFloat(r[1]);
        var a = ' ' + (box.dataset.tA || 'a') + ' ';
        t.textContent = mas > 0 ? '−' + menos + a + '+' + mas.toFixed(2) : '−' + menos + a + '0.00 ' + (box.dataset.tSoloMiopia || '(solo miopía)');
      });

      function graduado() {
        var fs = sec.querySelector('[data-opcion="' + box.dataset.recetaOpcion + '"]');
        var chk = fs && fs.querySelector('input:checked');
        var hid = fs && fs.querySelector('input[type=hidden]');
        var v = chk ? chk.value : (hid ? hid.value : '');
        return v === box.dataset.recetaValor;
      }
      function modo() {
        var m = box.querySelector('input[data-modo]:checked');
        return m ? m.dataset.modo : '';
      }
      function refrescar() {
        var g = graduado(), m = modo();
        box.hidden = !g;
        box.querySelectorAll('[data-panel]').forEach(function (p) {
          p.hidden = !g || p.dataset.panel.split(' ').indexOf(m) === -1;
        });
        // solo viaja al pedido lo que está a la vista; el eje solo si hay cilindro
        box.querySelectorAll('input, select').forEach(function (el) {
          var p = el.closest('[data-panel]');
          el.disabled = !g || (p ? p.hidden : false);
        });
        box.querySelectorAll('select[data-eje]').forEach(function (eje) {
          var cil = box.querySelector('select[data-cilindro="' + eje.dataset.eje + '"]');
          if (cil && parseFloat(cil.value) === 0) { eje.disabled = true; eje.value = ''; }
        });
        // el pago rápido no lleva la receta: con graduación solo se compra con el botón normal
        var pago = sec.querySelector('.shopify-payment-button');
        if (pago) pago.style.display = g ? 'none' : '';
        if (aviso) aviso.hidden = true;
        if (g && !vistoGraduado) { vistoGraduado = true; contar('graduado'); }
      }
      sec.querySelectorAll('[data-opcion] input[type=radio]').forEach(function (inp) { inp.addEventListener('change', refrescar); });
      box.querySelectorAll('input[data-modo], select[data-cilindro]').forEach(function (el) { el.addEventListener('change', refrescar); });
      // cualquier cambio en la receta quita el aviso anterior
      box.addEventListener('change', function () { if (aviso) aviso.hidden = true; });

      // antes de añadir a la bolsa (fase de captura: corre antes que product-form)
      if (pf) pf.addEventListener('submit', function (e) {
        if (!graduado()) return;
        var err = '', m = modo();
        var nombreOjo = { OD: box.dataset.tOd || 'ojo derecho', OI: box.dataset.tOi || 'ojo izquierdo' };
        if (m === 'valores') {
          ['OD', 'OI'].forEach(function (ojo) {
            var esf = box.querySelector('select[data-esfera="' + ojo + '"]');
            var cil = box.querySelector('select[data-cilindro="' + ojo + '"]');
            var eje = box.querySelector('select[data-eje="' + ojo + '"]');
            if (!err && esf && !esf.value) err = (box.dataset.tFaltaEsfera || 'Falta la esfera del [ojo].').replace('[ojo]', nombreOjo[ojo]);
            if (!err && cil && parseFloat(cil.value) !== 0 && eje && !eje.value) err = (box.dataset.tFaltaEje || 'Falta el eje del [ojo] (va junto con el cilindro).').replace('[ojo]', nombreOjo[ojo]);
          });
        } else {
          err = box.dataset.tEligeModo || 'Elige cómo nos das tu receta.';
        }
        if (err) {
          e.preventDefault();
          e.stopPropagation();
          if (aviso) { aviso.textContent = err; aviso.hidden = false; aviso.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        } else {
          if (aviso) aviso.hidden = true;
          contar('enviada');
        }
      }, true);
      refrescar();
    });
  }

  /* ---------- Receta → nota del carrito ----------
     DSers copia la nota del pedido al proveedor en cuanto entra el pedido y no la vuelve a leer, así que la receta
     tiene que estar en la nota ANTES de pagar. Mismo formato y marca que el lector de recetas (recetas-ia), que
     después la sustituye en Shopify por la suya ya revisada. */
  var MARCA_RX = '--- Helio Rx ---';
  var rxNum = function (v) { var n = parseFloat(v); return isNaN(n) ? null : n; };
  var rxFmt = function (v) { return (v > 0 ? '+' : '') + v.toFixed(2); };
  function rxOjo(p, ojo) {
    var esf = rxNum(p[ojo + ' Esfera (SPH)']) || 0, cil = rxNum(p[ojo + ' Cilindro (CYL)']) || 0, eje = rxNum(p[ojo + ' Eje (AXIS)']);
    // cilindro positivo → negativo (misma graduación, como la piden los laboratorios)
    if (cil > 0) { esf += cil; cil = -cil; eje = eje == null ? null : ((eje + 90) % 180) || 180; }
    if (eje === 0) eje = 180;
    return 'SPH ' + rxFmt(esf) + (cil !== 0 ? ' CYL ' + rxFmt(cil) + ' AXIS ' + eje : ' CYL 0.00');
  }
  function rxBloque(cart) {
    return cart.items.map(function (it) {
      var p = it.properties || {};
      var nombre = it.product_title + (it.variant_title ? ' / ' + it.variant_title : '') + ' x' + it.quantity;
      var lentes = (it.options_with_values || []).filter(function (o) { return o.name === 'Lentes' || o.name === 'Lenses'; })[0];
      if (p.Receta === 'Valores escritos') {
        return 'Rx single vision · ' + nombre + '\nOD (R): ' + rxOjo(p, 'OD') + '\nOS (L): ' + rxOjo(p, 'OI') + '\nPD ' + (rxNum(p['Distancia pupilar (PD)']) || 63);
      }
      if (p.Receta === 'Foto adjunta') return 'Rx single vision · ' + nombre + '\nPRESCRIPTION FROM PHOTO: values pending';
      // el proveedor de algunos modelos siempre gradúa: hay que decirle que va sin graduación
      if (lentes && (lentes.value === 'Sin graduación' || lentes.value === 'Without prescription')) return 'No prescription (plano, 0.00 both eyes) · ' + nombre;
      return '';
    }).filter(Boolean).join('\n\n');
  }
  var rxCola = Promise.resolve();
  function rxSincronizar() {
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    rxCola = rxCola.then(function () {
      return fetch(raiz + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var actual = cart.note || '';
        var previa = actual.split(MARCA_RX)[0].trim();
        var bloque = rxBloque(cart);
        var nueva = bloque ? (previa ? previa + '\n\n' : '') + MARCA_RX + '\n' + bloque : previa;
        if (nueva === actual) return;
        return fetch(raiz + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: nueva })
        });
      });
    }).catch(function () {});
    return rxCola;
  }
  function initNotaReceta() {
    if (window.mtNotaReceta) return;
    window.mtNotaReceta = true;
    rxSincronizar();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, rxSincronizar);
    // al pagar: primero la nota al día, luego el clic de verdad
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('button[name="checkout"]');
      if (!btn || btn.dataset.mtRx) return;
      e.preventDefault();
      e.stopPropagation();
      rxSincronizar().then(function () {
        btn.dataset.mtRx = '1';
        btn.click();
        delete btn.dataset.mtRx;
      });
    }, true);
  }

  /* ---------- Apertura con vídeo al ritmo del scroll ---------- */
  function initApertura(scope) {
    scope.querySelectorAll('[data-mt-apertura-video]').forEach(function (el) {
      if (el.dataset.mtListo) return;
      el.dataset.mtListo = '1';
      var v = el.querySelector('video');
      if (!v) return;
      if (reduceMotion) { el.classList.add('is-final'); return; }
      var objetivo = 0, actual = 0, dur = 0;
      v.addEventListener('loadedmetadata', function () { dur = v.duration || 0; });
      v.pause();
      function progreso() {
        var r = el.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        return total > 0 ? clamp(-r.top / total, 0, 1) : 0;
      }
      function bucle() {
        var p = progreso();
        el.classList.toggle('is-avanzado', p > 0.08);
        el.classList.toggle('is-final', p > 0.86);
        if (dur) {
          objetivo = p * (dur - 0.05);
          actual += (objetivo - actual) * 0.18;
          if (Math.abs(v.currentTime - actual) > 0.01) v.currentTime = actual;
        }
        requestAnimationFrame(bucle);
      }
      requestAnimationFrame(bucle);
    });
  }

  /* ---------- Apertura: secuencia de fotogramas al ritmo del scroll ---------- */
  function initSecuencia(scope) {
    scope.querySelectorAll('[data-mt-secuencia]').forEach(function (el) {
      if (el.dataset.mtListo) return;
      el.dataset.mtListo = '1';
      var esMovil = window.matchMedia('(max-width: 749px)').matches;
      // una o dos tiras de fotogramas (la segunda entra con un fundido)
      function tira(n, base, baseMovil) {
        var movil = esMovil && baseMovil && baseMovil.indexOf('-m-001') > -1;
        var b = movil ? baseMovil : base, marca = movil ? '-m-001.' : '-001.';
        return { n: n, imgs: new Array(n), url: function (i) { return b.replace(marca, (movil ? '-m-' : '-') + String(i + 1).padStart(3, '0') + '.'); } };
      }
      var tiras = [tira(parseInt(el.dataset.cantidad, 10) || 0, el.dataset.base, el.dataset.baseMovil)];
      var n2 = parseInt(el.dataset.cantidad2, 10) || 0;
      if (n2 > 1 && el.dataset.base2) tiras.push(tira(n2, el.dataset.base2, el.dataset.base2Movil));
      var doble = tiras.length > 1;
      // tramos del recorrido con dos tiras: 1ª tira, pausa (texto del medio), fundido, 2ª tira
      var T = { fin1: 0.4, pausa: 0.52, fundido: 0.6, fin2: 0.95 };
      var canvas = el.querySelector('canvas');
      var ctx = canvas.getContext('2d');
      var actual = '', suave = 0;
      function cargar(t, i) {
        if (t.imgs[i]) return t.imgs[i];
        var im = new Image(); im.decoding = 'async'; im.src = t.url(i); t.imgs[i] = im;
        im.onload = function () { actual = ''; };
        return im;
      }
      function lista(im) { return im && im.complete && im.naturalWidth; }
      // si aún no ha cargado, el más cercano ya cargado
      function imagen(t, i) {
        if (lista(t.imgs[i])) return t.imgs[i];
        for (var d = 1; d < t.n; d++) {
          if (lista(t.imgs[i - d])) return t.imgs[i - d];
          if (lista(t.imgs[i + d])) return t.imgs[i + d];
        }
        return null;
      }
      // qué se ve en el punto p del recorrido: [tira, fotograma, mezcla con el 1er fotograma de la 2ª tira]
      function estado(p) {
        var a = tiras[0];
        if (!doble) return [0, Math.round(p * (a.n - 1))];
        if (p < T.fin1) return [0, Math.round((p / T.fin1) * (a.n - 1))];
        if (p < T.pausa) return [0, a.n - 1];
        if (p < T.fundido) return [0, a.n - 1, Math.round(((p - T.pausa) / (T.fundido - T.pausa)) * 24) / 24];
        return [1, Math.round(Math.min(1, (p - T.fundido) / (T.fin2 - T.fundido)) * (tiras[1].n - 1))];
      }
      function pintar(im, alfa) {
        var cw = canvas.width, ch = canvas.height, iw = im.naturalWidth, ih = im.naturalHeight;
        var esc = Math.max(cw / iw, ch / ih);
        if (cw < ch) esc = Math.min(esc, (cw / iw) * 1.45); // móvil en vertical: que se vean las gafas completas
        var w = iw * esc, h = ih * esc;
        ctx.globalAlpha = alfa;
        ctx.drawImage(im, (cw - w) / 2, (ch - h) / 2, w, h);
        ctx.globalAlpha = 1;
      }
      function dibujar(forzar) {
        var e = estado(suave), clave = e.join(':');
        if (clave === actual && !forzar) return;
        var im = imagen(tiras[e[0]], e[1]);
        if (!im) return;
        ctx.fillStyle = '#0b0a09';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        pintar(im, 1);
        if (e.length > 2 && e[2] > 0) {
          var im2 = imagen(tiras[1], 0);
          if (im2) pintar(im2, e[2]);
        }
        actual = clave;
      }
      function medir() {
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = canvas.clientWidth * dpr; canvas.height = canvas.clientHeight * dpr;
        actual = ''; dibujar(true);
      }
      function progreso() {
        var r = el.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        return total > 0 ? clamp(-r.top / total, 0, 1) : 0;
      }
      // carga: primero el inicial, luego todos en orden (la 2ª tira después de la 1ª)
      cargar(tiras[0], 0);
      setTimeout(function () { tiras.forEach(function (t) { for (var i = 0; i < t.n; i++) cargar(t, i); }); }, 300);
      function bucle() {
        var p = progreso();
        el.classList.toggle('is-avanzado', p > 0.04);
        if (doble) el.classList.toggle('is-medio', p > T.fin1 - 0.04 && p < T.pausa + 0.01);
        el.classList.toggle('is-final', p > 0.9);
        suave += (p - suave) * (reduceMotion ? 1 : 0.22);
        dibujar();
        requestAnimationFrame(bucle);
      }
      window.addEventListener('resize', medir);
      medir();
      requestAnimationFrame(bucle);
    });
  }

  /* ---------- Portada «mirar a través»: zoom hacia los lentes al ritmo del scroll ---------- */
  function initMirada(scope) {
    scope.querySelectorAll('[data-mt-mirada]').forEach(function (el) {
      if (el.dataset.mtListo) return;
      el.dataset.mtListo = '1';
      var plano = el.querySelector('.mt-mirada__plano'), fondo = el.querySelector('.mt-mirada__fondo');
      if (!plano || !el.dataset.aspecto) return;
      var d = el.dataset, num = function (v) { return parseFloat(v) || 0; };
      var frente = (num(d.frenteDer) - num(d.frenteIzq)) / 100, ox = num(d.ox) / 100, oy = num(d.oy) / 100, aspecto = num(d.aspecto);
      var k0 = 1, suave = 0, antes = '', baja = 0;
      // los lentes acaban con el ancho elegido (sin pasarse de alto) y con los cristales a la altura elegida
      function medir() {
        var vw = el.clientWidth, vh = window.innerHeight, movil = vw < 750;
        var ancho = Math.min(vw * num(movil ? d.finalMovil : d.final) / 100, vh * 1.44);
        var w = ancho / frente, h = w * aspecto;
        plano.style.width = w + 'px';
        plano.style.left = (vw / 2 - w * ox) + 'px';
        plano.style.top = (vh * num(d.alto) / 100 - h * oy) + 'px';
        plano.style.transformOrigin = (ox * 100) + '% ' + (oy * 100) + '%';
        k0 = Math.min(1, vw * num(movil ? d.inicioMovil : d.inicio) / 100 / ancho);
        // al inicio los cristales van algo más abajo (debajo del título) y suben con el zoom
        baja = vh * (num(d.altoInicio || d.alto) - num(d.alto)) / 100;
        // la cabecera empuja la portada hacia abajo hasta que se pega: la pista sube lo mismo
        el.style.setProperty('--mt-mi-cab', Math.min(Math.max(el.getBoundingClientRect().top + window.scrollY, 0), 140) + 'px');
        antes = '';
      }
      function progreso() {
        var r = el.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        return total > 0 ? clamp(-r.top / total, 0, 1) : 0;
      }
      function bucle() {
        var p = progreso();
        suave += (p - suave) * (reduceMotion ? 1 : 0.2);
        // el zoom termina al 85 % del recorrido; escala geométrica = avance de cámara constante
        var t = reduceMotion ? 1 : clamp(suave / 0.85, 0, 1);
        t = t * t * (3 - 2 * t);
        var k = Math.pow(k0, 1 - t), clave = k.toFixed(4);
        if (clave !== antes) {
          plano.style.transform = 'translateY(' + (baja * (1 - t)).toFixed(1) + 'px) scale(' + clave + ')';
          el.style.setProperty('--mt-mi-t', t.toFixed(3));
          antes = clave;
        }
        // el paisaje "respira" muy despacio mientras nadie desliza
        var respira = reduceMotion ? 0 : 0.025 * (0.5 - 0.5 * Math.cos(performance.now() / 14000 * 2 * Math.PI)) * (1 - t);
        if (fondo) fondo.style.transform = 'scale(' + (1 + 0.18 * t + respira).toFixed(4) + ')';
        el.classList.toggle('is-avanzado', p > 0.03);
        el.classList.toggle('is-final', t > 0.97);
        requestAnimationFrame(bucle);
      }
      window.addEventListener('resize', medir);
      medir();
      requestAnimationFrame(bucle);
    });
  }

  function initTodo(scope) {
    scope = scope || document;
    initReveal(scope);
    initCaida(scope);
    initApertura(scope);
    initSecuencia(scope);
    initMirada(scope);
    initTono(scope);
    initEscena(scope);
    initComparador(scope);
    initFiltros(scope);
    initOpiniones(scope);
    initParallax(scope);
    initProducto(scope);
    initReceta(scope);
    initNotaReceta();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  } else {
    initTodo(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
